import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSparks12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSparks12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Sparks12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.415.307a.5.5 0 0 0-.5.5C8.915 1.465 8.381 2 7.723 2h-.001a.5.5 0 0 0 0 1c.66 0 1.193.535 1.193 1.194a.5.5 0 0 0 1 0c0-.66.534-1.194 1.194-1.194a.5.5 0 0 0 0-1c-.66 0-1.194-.534-1.194-1.193a.5.5 0 0 0-.5-.5m.3 2.193q-.165-.135-.3-.3-.135.165-.3.3.165.135.3.3.135-.165.3-.3M4.52 1.702a.5.5 0 0 0-.5.5A2.93 2.93 0 0 1 1.093 5.13h-.002a.5.5 0 0 0 0 1h.002A2.93 2.93 0 0 1 4.02 9.06a.5.5 0 0 0 1 0 2.93 2.93 0 0 1 2.928-2.93.5.5 0 1 0 0-1A2.93 2.93 0 0 1 5.02 2.202a.5.5 0 0 0-.5-.5M6.029 5.63a3.95 3.95 0 0 1-1.51-1.509 3.95 3.95 0 0 1-1.508 1.51A3.95 3.95 0 0 1 4.52 7.14a3.95 3.95 0 0 1 1.509-1.51m3.48 1.641a.5.5 0 0 1 .5.5v.864a.5.5 0 1 1-1 0V7.77a.5.5 0 0 1 .5-.5m0 4.455a.5.5 0 0 1-.5-.5v-.864a.5.5 0 1 1 1 0v.864a.5.5 0 0 1-.5.5M11.237 10a.5.5 0 0 0 0-1h-.864a.5.5 0 1 0 0 1zm-3.955-.5a.5.5 0 0 1 .5-.5h.864a.5.5 0 0 1 0 1h-.864a.5.5 0 0 1-.5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Sparks12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconSparks12);
